import gql from 'graphql-tag'



export const SEEUSER = gql`
         query seeUser($channelId: String!) {
           seeUser(channelId: $channelId) {
             channelId
             profileImageUrl
             displayName
             isSelf
             categoryCount
           }
         }
       `;